
import { useLanguage } from "@/contexts/LanguageContext";
import { Facebook, Instagram } from "lucide-react";
import Logo from "./Logo";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-secondary">
      <div className="section-container">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div>
            <h3 className="mb-4 text-lg font-semibold">{t("footer.quickLinks")}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-primary">
                  {t("nav.home")}
                </Link>
              </li>
              <li>
                <Link to="/find-places" className="hover:text-primary">
                  {t("nav.findPlaces")}
                </Link>
              </li>
              <li>
                <Link to="/rate-place" className="hover:text-primary">
                  {t("nav.ratePlace")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-lg font-semibold">{t("footer.information")}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="hover:text-primary">
                  {t("footer.about")}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-primary">
                  {t("footer.terms")}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-primary">
                  {t("footer.privacy")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-lg font-semibold">{t("footer.reachOut")}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/contact" className="hover:text-primary">
                  {t("footer.contact")}
                </Link>
              </li>
              <li>
                <a href="mailto:contact@goodvote.ge" className="hover:text-primary">
                  contact@goodvote.ge
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-lg font-semibold">{t("footer.socialNetworks")}</h3>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/share/1RHWi97pxP/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 bg-blue-600 hover:bg-blue-700 text-white rounded-full transition-colors duration-200"
                aria-label="Visit our Facebook page"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href="https://www.instagram.com/goodvote.ge" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 hover:from-purple-700 hover:via-pink-700 hover:to-orange-600 text-white rounded-full transition-colors duration-200"
                aria-label="Visit our Instagram page"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 border-t border-border pt-8 text-center">
          <Logo />
          <p className="mt-4 text-sm text-muted-foreground">
            © {new Date().getFullYear()} GoodVote.ge {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}
